var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//获取标签所有属性,返回键值对
_jquery2.default.fn.options = function () {
    var dom = this[0];
    return (0, _jquery2.default)(dom).attrs("opt");
};

_jquery2.default.fn.attrs = function (attrName) {
    var dom = this[0];
    var attributes = dom.attributes,
        opts = {};
    for (var i = 0; i < attributes.length; i++) {
        var attribute = attributes[i];
        if (_jquery2.default.trim(attribute.name.substr(0, attrName.length + 1)).toLowerCase() === attrName + "-") {
            opts[attribute.name.substr(attrName.length + 1)] = str2realType(attribute.value);
        }
    }
    return opts;
};

//将字符串转成最接近的数据类型
var str2realType = function str2realType(val) {
    if (typeof val !== 'string') return val;

    val = _jquery2.default.trim(val);
    if (parseInt(val).toString() === val) return parseInt(val);
    if (parseFloat(val).toString() === val) return parseFloat(val);
    if (typeof val === 'string' && val.toLowerCase() === 'true') return true;
    if (typeof val === 'string' && val.toLowerCase() === 'false') return false;
    if (typeof val === 'string' && val.substr(0, 1) === "{") return JSON.parse(val);

    return val;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/slothd/dist/Sloth/domEnhance.js
 ** module id = 2
 ** module chunks = 0
 **/